import type { UserProfile } from '~/prix'

const DEFAULT_SUGGESTED_QUESTIONS = [
  'O que merece atenção hoje?',
  'Quais são os insights mais relevantes agora?',
  'Há algum aumento fora do esperado nos atendimentos?',
  'Quais indicadores pioraram mais recentemente?',
]

export function getSuggestedQuestionsForUser(user: UserProfile | null): string[] {
  const preferredDelimitationTitle =
    user?.activeClient?.settings?.general?.preferredSpaceDelimitationTitle?.trim()

  if (!preferredDelimitationTitle) {
    return DEFAULT_SUGGESTED_QUESTIONS
  }

  return [
    `O que merece atenção hoje em ${preferredDelimitationTitle}?`,
    `Quais são os insights mais relevantes em ${preferredDelimitationTitle}?`,
    `Há algum aumento fora do esperado nos atendimentos em ${preferredDelimitationTitle}?`,
    `Quais indicadores pioraram mais recentemente em ${preferredDelimitationTitle}?`,
  ]
}
